import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import settings from './modules/settings'
import user from './modules/user'
import exam from './modules/exam'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    settings,
    user,
    exam
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js